<!-- `appendTo="body"` es obligatorio: este diálogo se monta desde el shell, y sin eso cualquier
     ancestro con transform u overflow lo recortaría. Además así toma el z-index siguiente cuando se
     abre encima de otro modal, que es el caso que motiva toda la herramienta. -->
<p-dialog
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [closable]="!sending"
  [dismissableMask]="false"
  [closeOnEscape]="!sending"
  [draggable]="false"
  appendTo="body"
  [style]="{ width: '560px' }"
  [breakpoints]="{ '620px': '96vw' }"
  styleClass="bug-report-dialog"
  header="Reportar un problema"
  (onHide)="close()">

  <!-- Confirmación: el folio a la vista y copiable, igual que en el alta de tareas. -->
  <div class="bug-created" *ngIf="createdCode as code">
    <span class="bc-check"><i class="fa-solid fa-circle-check"></i></span>
    <p class="bc-lead">Ya lo reportamos. Gracias por avisarnos.</p>
    <button type="button" class="bc-code" (click)="copyCode()" [title]="'Copiar ' + code">
      {{ code }}
      <i class="fa-solid" [class.fa-copy]="!copiado" [class.fa-check]="copiado"></i>
    </button>
    <p class="bc-hint" *ngIf="!copiado">Guarda este folio: con él puedes preguntar en qué va.</p>
    <p class="bc-hint ok" *ngIf="copiado">Copiado al portapapeles.</p>

    <ul class="bc-warnings" *ngIf="warnings.length">
      <li *ngFor="let w of warnings"><i class="fa-solid fa-circle-info"></i> {{ w }}</li>
    </ul>
  </div>

  <form [formGroup]="form" class="bug-form" *ngIf="!createdCode">
    <!-- El título llega resuelto. Se ve como un campo ya contestado; al enfocarlo se vuelve
         editable de aspecto y deja de recalcularse solo. -->
    <div class="bug-field">
      <label for="bug-title">Título</label>
      <input id="bug-title" type="text" pInputText formControlName="title" class="bug-title-input" maxlength="160" />
      <small class="bug-help">Lo escribimos por ti a partir de dónde estabas. Cámbialo si quieres.</small>
    </div>

    <div class="bug-field">
      <label for="bug-desc">¿Qué pasó? <span class="req">*</span></label>
      <textarea
        id="bug-desc"
        pInputTextarea
        formControlName="description"
        rows="5"
        cdkFocusInitial
        (paste)="onPaste($event)"
        placeholder="Cuéntalo como se lo contarías a un compañero: qué estabas haciendo, qué esperabas y qué pasó en su lugar.&#10;&#10;Ej.: «Estaba en Pagos, registré el pago de un cliente y al dar Guardar no pasó nada.»"></textarea>
      <small class="bug-err" *ngIf="descriptionInvalid">
        Cuéntanos un poquito más: con una frase completa el equipo puede repetir lo que te pasó.
      </small>
    </div>

    <div class="bug-field">
      <label>Capturas <span class="bug-optional">· opcional, pega con {{ pasteKey }} o arrastra</span></label>

      <div class="bug-shots">
        <div class="bug-shot" *ngFor="let shot of shots">
          <img [src]="shot.preview" alt="Captura adjunta" />
          <button type="button" class="bug-shot-x" (click)="removeShot(shot)" title="Quitar esta captura" aria-label="Quitar esta captura">
            <i class="fa-solid fa-xmark"></i>
          </button>
          <span class="bug-shot-tag" *ngIf="shot.automatic">automática</span>
        </div>

        <!-- Hueco mientras el rasterizado termina: la captura de la pantalla entra sola aquí. -->
        <div class="bug-shot is-loading" *ngIf="capturando">
          <i class="fa-solid fa-spinner fa-spin"></i>
          <span>tomando captura…</span>
        </div>

        <label class="bug-drop" (drop)="onDrop($event)" (dragover)="onDragOver($event)" *ngIf="shots.length < 4">
          <input type="file" accept="image/*" multiple hidden (change)="onFilesChosen($event)" />
          <i class="fa-solid fa-image"></i>
          <span>Arrastra una imagen<br />o haz clic para elegirla</span>
        </label>
      </div>
    </div>

    <!-- El aviso de qué se manda, con la lista real desplegable. Es lo que hace que la frase sea
         verificable y no una promesa: cualquiera puede abrirla y ver exactamente qué viaja. -->
    <div class="bug-notice">
      <i class="fa-solid fa-circle-info"></i>
      <div>
        <p>
          Enviamos también tus últimos pasos en la plataforma para que el equipo pueda repetir lo que te pasó.
          No incluimos lo que escribes en los formularios ni tus contraseñas.
        </p>
        <button type="button" class="bug-link" (click)="showTrace = !showTrace">
          {{ showTrace ? 'Ocultar' : 'Ver qué se envía' }}
          <i class="fa-solid" [class.fa-chevron-down]="!showTrace" [class.fa-chevron-up]="showTrace"></i>
        </button>

        <ol class="bug-trace-list" *ngIf="showTrace">
          <li *ngFor="let e of tracePreview">{{ e.label }}</li>
          <li class="empty" *ngIf="!tracePreview.length">Todavía no hay pasos registrados en esta pantalla.</li>
        </ol>
      </div>
    </div>

    <div class="bug-alert" *ngIf="sendError">
      <i class="fa-solid fa-triangle-exclamation"></i> {{ sendError }}
    </div>
  </form>

  <ng-template pTemplate="footer">
    <ng-container *ngIf="createdCode; else pieFormulario">
      <button type="button" class="bug-btn ghost" (click)="otro()"><i class="fa-solid fa-plus"></i> Reportar otro</button>
      <button type="button" class="bug-btn primary" (click)="close()">Listo</button>
    </ng-container>

    <ng-template #pieFormulario>
      <button type="button" class="bug-btn ghost" [disabled]="sending" (click)="close()">Cancelar</button>
      <button type="button" class="bug-btn primary" [disabled]="!canSend" (click)="submit()">
        <i class="fa-solid" [class.fa-paper-plane]="!sending" [class.fa-spinner]="sending" [class.fa-spin]="sending"></i>
        {{ sending ? 'Enviando…' : sendError ? 'Reintentar' : 'Enviar reporte' }}
      </button>
    </ng-template>
  </ng-template>
</p-dialog>

<!-- Toast propio con `key`: el del header no la tiene y se comería estos mensajes, además de que
     queda por debajo de la máscara del diálogo. `baseZIndex` lo pone sobre la pila de diálogos. -->
<p-toast key="bugreport" position="top-center" [baseZIndex]="1300"></p-toast>
